import React, { useEffect, useRef } from "react";
import { StyleSheet } from "react-native";
import { LoaderIndicatorProps, LoaderIndicator } from "./loader-indicator";
import { theme, Modal } from "ui-components";
import { convertHexToRGBA } from "../../../utils/general";
import { Text } from "ui-components";

export interface FullScreenLoaderProps {
  testID?: string;
  accessibilityLabel?: string;
  loading: boolean;
  loaderIndicatorProps?: LoaderIndicatorProps;
  textLabel?: string;
}

export const FullScreenLoader = (props: FullScreenLoaderProps) => {
  const { accessibilityLabel, loading, testID, loaderIndicatorProps, textLabel } = props;
  const styles = getStyles();

  const modalRef = useRef<any>();

  useEffect(() => {
    if (loading) modalRef?.current?.open();
    else modalRef?.current?.close();
  }, [loading]);
  return (
    <>
      <Modal
        ref={modalRef}
        animationType={"none"}
        testID={testID + "-full-screen-loader"}
        accessibilityLabel={accessibilityLabel + " full screen loader"}
        closeOnPressBack={false}
        closeOnPressMask={false}
        showCloseIcon={false}
        onDismiss={() => {}}
        containerStyle={{
          backgroundColor: theme.colors.transparent,
          shadowColor: theme.colors.transparent,
        }}
        wrapperStyle={{ backgroundColor: convertHexToRGBA("#000", 0.3) }}>
        <LoaderIndicator
          testID={testID}
          accessibilityLabel={accessibilityLabel}
          {...loaderIndicatorProps}
        />
        {textLabel && <Text style={styles.text}>{textLabel}</Text>}
      </Modal>
    </>
  );
};

const getStyles = () => {
  return StyleSheet.create({
    text: {
      textAlign: "center",
      paddingTop: 15,
    },
  });
};
